import { apiGet, apiPostMultipart, apiDelete } from 'helpers/ApiHelper';

import * as notificationActions from './notificationActions';

import Auth from 'j-toker';

export function getDocuments(mode) {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/api_dashboard/${mode}/documents`)
        .done(response => {
          if (response.documents) {
            dispatch(displayDocuments(response));
          }
        })
        .catch((error, textStatus) => {
          dispatch(notificationActions.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function openDocument(mode, uuid) {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/api_dashboard/${mode}/documents/${uuid}?recreate=true`)
        .done(response => {
          if (response.document) {
            displayDocument(response.document.url);
          }
        })
        .catch((error, textStatus) => {
          dispatch(notificationActions.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function viewDocumentInformation(mode, uuid) {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/api_dashboard/${mode}/documents/${uuid}`)
        .done(response => {
          if (response.document) {
            dispatch(displayDocumentInformation(response.document));
          }
        })
        .catch((error, textStatus) => {
          dispatch(notificationActions.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function cancelDocument(mode, uuid) {
  return dispatch => {
    return dispatch({
      payload: apiDelete(Auth.getApiUrl() + `/api_dashboard/${mode}/documents/${uuid}`)
        .done(response => {
          dispatch(notificationActions.showSuccess('successfullyCancelledDocument'));
          dispatch(getDocuments(mode));
        })
        .catch((error, textStatus) => {
          dispatch(notificationActions.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function clearDocument() {
  return dispatch => {
    return dispatch(displayDocumentInformation(null));
  };
}

export function displayDocuments(response) {
  return {
    type: 'LANDLORD_API_DASHBOARD::SHOW_DOCUMENTS',
    documents: response.documents,
    statistics: response.statistics,
  };
}

export function displayDocumentInformation(document) {
  return {
    type: 'LANDLORD_API_DASHBOARD::SHOW_DOCUMENT_INFORMATION',
    document,
  };
}

function displayDocument(url) {
  window.open(url, '_blank');
}

export function getLogos(mode) {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/api_dashboard/${mode}/logos`)
        .done(response => {
          if (response.logos) {
            dispatch(displayLogos(response));
          }
        })
        .catch((error, textStatus) => {
          dispatch(notificationActions.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function displayLogos(response) {
  return {
    type: 'LANDLORD_API_DASHBOARD::SHOW_LOGOS',
    logos: response.logos,
  };
}

export function deleteLogo(mode, id) {
  return dispatch => {
    return dispatch({
      payload: apiDelete(Auth.getApiUrl() + `/api_dashboard/${mode}/logos/${id}`)
        .done(response => {
          dispatch(notificationActions.showSuccess('successfullyDeletedLogo'));
          dispatch(getLogos(mode));
        })
        .catch((error, textStatus) => {
          dispatch(notificationActions.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function postLogo(mode, name, image) {
  const data = new FormData();
  data.append('name', name);
  data.append('image', image);

  return dispatch => {
    return dispatch({
      payload: apiPostMultipart(Auth.getApiUrl() + `/api_dashboard/${mode}/logos`, data)
        .done(response => {
          dispatch(notificationActions.showSuccess('successfullyCreatedLogo'));
          dispatch(getLogos(mode));
        })
        .catch((error, textStatus) => {
          dispatch(notificationActions.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function putLogo(mode, id, image) {
  const data = new FormData();
  data.append('image', image);

  return dispatch => {
    return dispatch({
      payload: apiPostMultipart(Auth.getApiUrl() + `/api_dashboard/${mode}/logos/${id}`, data)
        .done(response => {
          dispatch(notificationActions.showSuccess('successfullyUpdatedLogo'));
          dispatch(getLogos(mode));
        })
        .catch((error, textStatus) => {
          dispatch(notificationActions.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function clearDocuments() {
  return displayDocuments({ documents: null, statistics: null });
}
